import {
	FundamentalContextProvider,
	ToastContainer,
	ThemeProvider,
} from "@hm/fundamental"
import { FundamentalHooksContextProvider } from "@hm/fundamental-hooks"
import "flag-icons/css/flag-icons.min.css"
import React from "react"
import ReactDOM from "react-dom/client"

import "../shared/i18n"
import {
	AnalyticsShellProvider,
	ErrorBoundaryProvider,
	FcpAuthProvider,
	FcpApiClientProvider,
} from "./providers"
import { LegalProvider } from "./providers/legal"
import CarbonBankRouter from "./router"
import "./styles/index.css"

const container = ReactDOM.createRoot(document.getElementById("root")!)

container.render(
	<React.StrictMode>
		<FundamentalContextProvider>
			<FundamentalHooksContextProvider>
				<ThemeProvider>
					<FcpAuthProvider>
						<FcpApiClientProvider>
							<AnalyticsShellProvider>
								<ErrorBoundaryProvider>
									<LegalProvider
										product="carbonbank"
										region="ww"
										documentTypes={["tc", "dpp"]}
										languages={["en"]}
									>
										<CarbonBankRouter />
										<ToastContainer />
									</LegalProvider>
								</ErrorBoundaryProvider>
							</AnalyticsShellProvider>
						</FcpApiClientProvider>
					</FcpAuthProvider>
				</ThemeProvider>
			</FundamentalHooksContextProvider>
		</FundamentalContextProvider>
	</React.StrictMode>,
)
